import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { getContractState } from '@client/selectors';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HasNoContractGuard implements CanActivate {
  constructor(private store: Store<any>, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> {
    return this.store.pipe(
      select(getContractState),
      filter(x => x.isLoaded !== null),
      mergeMap(s => {
        const isCompleted = (s.data && s.data.isCreationCompleted) || null;

        if (!isCompleted) {
          return of(true);
        }
        return this.router.navigate(['/account/contract/details']);
      })
    );
  }
}
